import { API_ENDPOINT, httpService } from "../../core/services/http.service";
import { TokenDO } from "../../tokenData/models/tokenDO.models";

class AssetScreenerService {
    private readonly API_PATH = `${API_ENDPOINT}/screener`

    async getTokenData(tokenSlug: string): Promise<TokenDO[]> {
        try {
            const queryParams = new URLSearchParams()
            queryParams.set('slugs', tokenSlug)
            const response = await httpService.query(`${this.API_PATH}/fromSlugs?${queryParams.toString()}`, {
                method: 'GET'
            })
            if (!response.ok) { throw new Error('Failed to fetch token data') }
            return (await response.json()) as TokenDO[]
        } catch (error) {
            console.error(error)
            return []
        }
    }
}

export const assetScreenerService = new AssetScreenerService()